import { Dialog } from "@/components/ui/dialog";
import { ContactSubmissionDetailDialog } from "../-components/contact-submission-detail-dialog";
import {
  getContactSubmissionsGetContactSubmissionQueryOptions,
  useContactSubmissionsGetContactSubmission,
} from "@/orval/contact-submissions";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ensureRouteQueryData } from "@/lib/route-loader";
import { parseContactSubmissionIdParams } from "@/lib/route-params";

export const Route = createFileRoute("/_app/site-admin/contact-submissions/$contactSubmissionId")({
  params: {
    parse: parseContactSubmissionIdParams,
  },
  loader: ({ params, ...loaderContext }) =>
    ensureRouteQueryData(
      loaderContext,
      getContactSubmissionsGetContactSubmissionQueryOptions(params.contactSubmissionId),
    ),
  component: ContactSubmissionDialogRoute,
});

function ContactSubmissionDialogRoute() {
  const navigate = useNavigate();
  const { contactSubmissionId } = Route.useParams();
  const { data: selectedSubmission, isLoading } = useContactSubmissionsGetContactSubmission(contactSubmissionId!, {
    query: { enabled: !!contactSubmissionId },
  });

  const handleStatusUpdate = () => {
    navigate({ to: "/site-admin/contact-submissions" });
  };

  return (
    <Dialog open onOpenChange={(open) => !open && navigate({ to: "/site-admin/contact-submissions" })}>
      <ContactSubmissionDetailDialog
        submission={selectedSubmission}
        isLoading={isLoading}
        onStatusUpdate={handleStatusUpdate}
      />
    </Dialog>
  );
}
